import BookReader from '../components/book-viewer/BookReader';

const BookView = () => {
    return <BookReader />;
};

export default BookView;
